<template>
  <article v-if="!loading" itemprop="articleBody">
    <div class="question-choices" v-bind:class="{ full: !this.activeQuestion.additional_image }">
        <div class="inner">
            <header>
                <h1 v-html="activeQuestion.text" class="display-inline"></h1><question-remark v-bind:question_id="this.activeQuestion.id"></question-remark>
            </header>
            <div v-if="this.activeQuestion.additional_image" class="media">
              <div class="inner">
                <figure>
                  <img :src="this.activeQuestion.additional_image" alt="Bild" />
                </figure>
              </div>
            </div>
            <form class="form-container">
                <div class="choices">
                    <div class="opt-in" v-for="(solution, index) in activeQuestion.solutions.data" v-on:click="selectSolution(solution)">
                        <input class="regular-checkbox" type="radio" :id="'checkbox-' + activeQuestion.id + '-' + index" :name="'question-' + activeQuestion.id" v-model="activeSolution" :value="solution.solution_id" />
                        <label :for="'checkbox-' + activeQuestion.id + '-' + index">
                            <span v-html="solution.text"></span>
                        </label>
                    </div>
                </div>
             </form>
        </div>
    </div>
    <div class="buttons">
      <button class="previous no-margin" type="button" v-on:click="getPrevQuestion">
          <i class="fa fa-angle-left left" aria-hidden="true"></i>
      </button>

      <div v-for="(question, index) in this.exam.questions.data">
        <button type="button" class="numbered" v-bind:class="{ active: questionIsActive(index), done: questionIsBeforeCurrent(index) }" v-on:click="getQuestionByNumber(index)">
          <span>{{ index + 1 }}</span>
        </button>
      </div>
      <button class="next" type="button" v-on:click="getNextQuestion">
          <span v-if="nextQuestionExists() > -1">Nächste Frage</span>
          <span v-else>Check beenden</span>
          <i class="fa fa-angle-right right" aria-hidden="true"></i>
      </button>
    </div>
  </article>
</template>

<script>
import axios from 'axios';
import config from '../config.js';
import QuestionRemark from '../components/QuestionRemark.vue'

export default {
  data: function() {
    return {
      loading: true,
    }
  },
  components: {
    'question-remark': QuestionRemark
  },
  watch: {
    activeQuestion: function() {
      this.$nextTick(function() {
        MathJax.Hub.Queue(["Typeset",MathJax.Hub]);
      })
    }
  },
  methods: {
    solutionIsActive: function(solution) {
      const exists = this.challenges.find(item => item.question_id == this.activeQuestion.id)
      if (exists && exists.solution_choice == solution.solution_id) {
        return true
      }
      return false
    },
    selectSolution: function(solution) {
      const exists = this.challenges.find(item => item.question_id == this.activeQuestion.id)
      if (exists) {
        this.$store.dispatch('removeChallenge', exists)
      }
      const newChallenge = {
        "exam_uid": this.exam.uid,
        "question_id": this.activeQuestion.id,
        "solution_choice": solution.solution_id
      }
      this.$store.dispatch('addChallenge', newChallenge)

      axios.post(
          config.api_url + '/challenge',
          JSON.stringify(newChallenge)
        )
        .catch((error) => {
          console.log(error);
        });

    },
    questionIsActive: function(index) {
      var question = this.exam.questions.data[index]
      if (this.activeQuestion && question) {
        if (this.activeQuestion.id == question.id) {
          return true
        }
      }
      return false
    },
    questionIsBeforeCurrent: function(index) {
      var indexOfCurrent = this.exam.questions.data.findIndex(item => item.id == this.activeQuestion.id)
      if (index < indexOfCurrent)
        return true
      return false
    },
    loadExam: function() {
      if (!this.exam || !this.exam.uid) {
        axios.get(config.api_url + '/exam/' + this.$route.params.uid)
          .then(response => {
            this.exam = response.data
            this.activeQuestion = this.exam.questions.data[0]
            this.loading = false
          })
      } else {
        this.activeQuestion = this.exam.questions.data[0]
        this.loading = false
      }
    },
    prevQuestionExists: function () {
      var index = this.exam.questions.data.findIndex(item => item.id == this.activeQuestion.id)
      if (this.exam.questions.data[index - 1]) {
        return index - 1
      } else {
        return -1
      }
    },
    nextQuestionExists: function () {
      var index = this.exam.questions.data.findIndex(item => item.id == this.activeQuestion.id)
      if (this.exam.questions.data[index + 1]) {
        return index + 1
      } else {
        return -1
      }
    },
    getNextQuestion: function() {
      var index = this.nextQuestionExists()
      if (index > -1) {
        this.loading = true
        this.activeQuestion = this.exam.questions.data[index]
        this.loading = false
      } else {

        axios.post(
            config.api_url + '/exam/finish',
            JSON.stringify({ exam_uid: this.exam.uid }),
            {
                headers: {
                    'Accept': 'application/json',
                    'Content-type': 'application/json',
                }
            }
        )
            .then((response) => {
            this.$router.push({ name: 'finish-exam' })
          })
          .catch((error) => {
            console.log(error)
            alert('Es ist ein Fehler unterlaufen. Bitte versuche es erneut.')
          });

      }
    },
    getPrevQuestion: function() {
      var index = this.prevQuestionExists()
      if (index > -1) {
        this.loading = true
        this.activeQuestion = this.exam.questions.data[index]
        this.loading = false
      }
    },
    getQuestionByNumber: function(pNumber) {
      if (this.exam.questions.data[pNumber]) {
        this.loading = true
        this.activeQuestion = this.exam.questions.data[pNumber]
        this.loading = false
      }
    }
  },
  mounted: function() {
    this.loadExam();
    gtag('config', 'UA-51770849-8', {'page_path': '/exam'});
  },
  computed: {
    exam: {
      get () {
        return this.$store.getters.exam;
      },
      set (value) {
        this.$store.dispatch('updateExam', value)
      }
    },
    activeQuestion: {
      get () {
        return this.$store.getters.activeQuestion;
      },
      set (value) {
        this.$store.dispatch('updateActiveQuestion', value)
      }
    },
    challenges: {
      get () {
        return this.$store.getters.challenges;
      },
      set (value) {
        this.$store.dispatch('updateChallenges', value)
      }
    },
    activeSolution: {
      get () {
        return this.$store.getters.activeSolution;
      },
      set (value) {
        this.$store.dispatch('updateActiveSolution', value)
      }
    },
  }
}
</script>

<style type="text/css">
  .display-inline {
    display: inline;
  }
</style>



// WEBPACK FOOTER //
// src/components/Exam.vue